import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenu } from '@angular/material';

@Component({
  selector: 'fc-button',
  templateUrl: './fc-button.component.html',
  styleUrls: ['./fc-button.component.scss']
})
export class FcButtonComponent {
  @Input() label: string;
  @Input() primary: boolean;
  @Input() outline: boolean;
  @Input() large: boolean;
  @Input() menu: MatMenu;
  @Input() disabled: boolean;
  @Output() click = new EventEmitter();
}
